import React, { Component } from "react";
import { Input, Measurement, MeasurementList } from "../../../../../form-inputs/inputs";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrash } from "@fortawesome/free-solid-svg-icons";

import { DEFAULT_RANGE } from "./lib/constant";

class Range extends Component {
    constructor(props) {
        super(props);
        const range = props.range || {};

        this.state = {
            ...DEFAULT_RANGE,
            ...range,
        };
    }

    static getDerivedStateFromProps(nextProps) {
        return {
            ...nextProps.range,
        };
    }

    updateState = (key, value) => {
        this.setState({
            [key]: value,
        });

        const payload = { ...this.props.range, [key]: value };
        this.props.updateRange(this.props.id, payload);
    };

    render() {
        const range = { ...this.state };

        return (
            <div className="range-container">
                <div className="range-title">
                    <h3>Slider Range </h3>
                    <div>
                        <button
                            className="button -small -error"
                            onClick={() => {
                                this.props.delete(this.props.id);
                            }}
                        >
                            <FontAwesomeIcon icon={faTrash} />
                        </button>
                    </div>
                </div>
                <div className="selected-value">
                    <Input label="Selected Title" name="selectedTitle" value={range.selectedTitle} updateOnChange={this.updateState} />
                    <div>
                        <MeasurementList
                            label="Selected Value"
                            name="selectedValue"
                            value={range.selectedValue}
                            updateOnChange={this.updateState}
                            filter={["lighting"]}
                        />
                    </div>
                </div>

                <div className="range-label">
                    <div className="vertical-text">Ranges</div>
                    <Input label="Range Title" name="label" defaultValue={range.label} updateOnChange={this.updateState} className="-full" />
                    <div className="input-group">
                        <Measurement label="Low" name="low" defaultValue={range.low} updateOnChange={this.updateState} filter={["lighting"]} />
                        <Measurement label="High" name="high" defaultValue={range.high} updateOnChange={this.updateState} filter={["lighting"]} />
                    </div>
                </div>
                <Input label="Legend Text" name="legendText" value={range.legendText} updateOnChange={this.updateState} />
            </div>
        );
    }
}

export default Range;
